<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="title-tab-experience-manager">APPLICATION MANAGER</div>
      <div class="d-flex m__t--42">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'apps'}"
          class="tab-experience-manager m__r--35"
          @click="tabSelected = 'apps'">
          APPLICATION
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'group'}"
          class="tab-experience-manager"
          @click="tabSelected = 'group'">
          GROUP APPS
        </div>
      </div>
    </div>

    <div class="studio-page-content">
      <v-client-table
        v-show="load_first && tabSelected === 'apps'"
        :data="data_apps"
        :columns="columns"
        :options="table_options"
        class="jTable">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="isModalAppTypeOpen(true)">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filter(filter_data)">
              <j-select
                v-model="select_type"
                :options="options_search"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInputApp"
                v-model="filter_data"
                type="text"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="id"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          {{ props.row.id }}
        </div>

        <div
          slot="icon"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          <img
            v-if="props.row.icon"
            :src="props.row.icon"
            width="32">
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          {{ props.row.name }}
        </div>

        <div
          slot="is_offline_mode"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          <div
            v-if="props.row.is_offline_mode"
            class="vp-on">ON</div>
          <div
            v-else
            class="vp-off">OFF</div>
        </div>

        <div
          slot="total_page"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          {{ props.row.total_page || 0 }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="detailApp(props.row.id_hash)">
          {{ convertDateTime(props.row.updated_at) }}
        </div>
      </v-client-table>
      <jLoadingTable v-if="!load_first && tabSelected === 'apps'"/>

      <v-client-table
        v-show="load_first_group && tabSelected === 'group'"
        :data="data_group_apps"
        :columns="columns_group"
        :options="table_options_group"
        class="jTable">
        <div
          slot="beforeFilter"
          class="custom-search">
          <b-form inline>
            <b-button
              class="btn grey btn-import-form m__r--5"
              @click="isModalAppGroupOpen(true)">
              <i class="fa fa-plus fa-lg"/> Add
            </b-button>
            <b-form
              inline
              @keypress.13.prevent="filterGroup(filter_data_group)">
              <j-select
                v-model="select_type_group"
                :options="options_search_group"
                placeholder="Filter By"
                class="m__r--5"/>
              <b-form-input
                ref="filterInputGroup"
                v-model="filter_data_group"
                placeholder="Search"
                style="width: 250px; height: 35px"/>
            </b-form>
          </b-form>
        </div>

        <div
          slot="id"
          slot-scope="props"
          @click="detailGroup(props.row.id)">
          {{ props.row.id }}
        </div>

        <div
          slot="name"
          slot-scope="props"
          @click="detailGroup(props.row.id)">
          {{ props.row.name }}
        </div>

        <div
          slot="count_apps"
          slot-scope="props"
          @click="detailGroup(props.row.id)">
          {{ props.row.count_apps || 0 }}
        </div>

        <div
          slot="created_at"
          slot-scope="props"
          @click="detailGroup(props.row.id)">
          {{ convertDateTime(props.row.created_at) }}
        </div>

        <div
          slot="updated_at"
          slot-scope="props"
          @click="detailGroup(props.row.id)">
          {{ convertDateTime(props.row.updated_at) }}
        </div>
      </v-client-table>
      <jLoadingTable v-if="!load_first_group && tabSelected === 'group'"/>
    </div>

    <b-modal
      ref="appTypeModal"
      class="mod-form modal-app-type"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <j-modal-app-type
        @modal-open="isModalAppTypeOpen"
        @type-mode="typeMode"
      />
    </b-modal>

    <b-modal
      ref="appGroupModal"
      class="mod-form modal-app-type"
      centered
      no-close-on-esc
      no-close-on-backdrop
    >
      <j-modal-create-group
        @modal-open="isModalAppGroupOpen"
      />
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState, mapActions } from 'vuex';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jModalAppType from '@/views/setting/jModalAppType';
import jModalCreateGroup from '@/views/setting/jModalCreateGroup';

export default {
  name: 'JApplicationSetting',
  components: {
    jLoadingTable,
    jModalAppType,
    jModalCreateGroup,
  },
  data() {
    return {
      tabSelected: 'apps',

      // Apps
      data_apps: [],
      load_first: false,
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'icon', 'name', 'is_offline_mode', 'total_page', 'created_at', 'updated_at'],
      table_options: {
        headings: {
          id: 'ID',
          icon: 'LOGO',
          name: 'NAME',
          is_offline_mode: 'OFFLINE MODE',
          total_page: 'TOTAL PAGES',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },

      // Group Apps
      data_group_apps: [],
      load_first_group: false,
      filter_data_group: '',
      select_type_group: 'name',
      options_search_group: [
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns_group: ['id', 'name', 'count_apps', 'created_at', 'updated_at'],
      table_options_group: {
        headings: {
          id: 'ID',
          name: 'GROUP NAME',
          count_apps: 'TOTAL APPS',
          created_at: 'CREATED AT',
          updated_at: 'UPDATED AT',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        perPage: 10,
        perPageValues: [10, 50, 100, 500, 1000],
      },

      options: {
        icon: 'fa-user',
        main_title: 'APPLICATION',
        opt_title: 'Administrator',
      },
      appName: '',
      listApp: [],
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['applications_list', 'group_applications_list', 'is_sidebar_minimized']),
  },
  watch: {
    // eslint-disable-next-line
    'applications_list': function() {
      this.load_first = true;
      this.data_apps = this.applications_list;
    },

    // eslint-disable-next-line
    'group_applications_list': function() {
      this.load_first_group = true;
      this.data_group_apps = this.group_applications_list;
    },
    load_first(val) {
      if (val) {
        setTimeout(() => {
          if (this.tabSelected === 'apps') {
            this.$refs.filterInputApp.focus();
          } else {
            this.$refs.filterInputGroup.focus();
          }
        }, 200);
      }
    },
    tabSelected(val) {
      setTimeout(() => {
        if (val === 'apps') {
          this.$refs.filterInputApp.focus();
        } else {
          this.$refs.filterInputGroup.focus();
        }
      }, 200);
    },
  },
  created() {
    this.getDataApps();
    this.getDataGroupApps();
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionGetApplicationsList', 'actionGetGroupApplicationsList']),

    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    getDataApps() {
      const parameter = {
        page: 1,
        limit: 10000,
        column: 'updated_at',
        sort: 'desc',
      };
      this.actionGetApplicationsList({ params: parameter });
    },

    getDataGroupApps() {
      const param = {
        params: {
          page: 1,
          limit: 0,
          column: 'updated_at',
          sort: 'desc',
          query: '',
          query_type: '',
        },
      };
      this.actionGetGroupApplicationsList(param);
    },

    filter(val) {
      this.data_apps = this.applications_list.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    filterGroup(val) {
      this.data_group_apps = this.group_applications_list.filter(app =>
        app.name.toUpperCase().includes(val.toUpperCase()));
    },

    isModalAppTypeOpen(val) {
      if (val) {
        this.$refs.appTypeModal.show();
      } else {
        this.$refs.appTypeModal.hide();
      }
    },
    isModalAppGroupOpen(val) {
      if (val) {
        this.$refs.appGroupModal.show();
      } else {
        this.$refs.appGroupModal.hide();
      }
    },
    isModalCreateAppOpen(val) {
      if (val) {
        this.$refs.createAppModal.show();
      } else {
        this.$refs.createAppModal.hide();
      }
    },
    isModalHyperlinkAppOpen(val) {
      if (val) {
        this.$refs.hyperlinkApplicationModal.show();
      } else {
        this.$refs.hyperlinkApplicationModal.hide();
      }
    },
    isModalStandaloneAppOpen(val) {
      if (val) {
        this.$refs.standaloneApplicationModal.show();
      } else {
        this.$refs.standaloneApplicationModal.hide();
      }
    },
    isModalCreateNewAppOpen(val) {
      if (val) {
        this.$refs.createNewApplicationModal.show();
      } else {
        this.$refs.createNewApplicationModal.hide();
      }
    },
    isModalCreateWithTemplate(val) {
      if (val) {
        this.$refs.createWithTemplateModal.show();
      } else {
        this.$refs.createWithTemplateModal.hide();
      }
    },
    typeMode(val) {
      if (val === 'native') {
        this.isModalCreateAppOpen(true);
      } else if (val === 'hyperlink') {
        this.isModalHyperlinkAppOpen(true);
      } else if (val === 'standalone') {
        this.isModalStandaloneAppOpen(true);
      }
    },
    createMode(val) {
      if (val === 'blank') {
        this.isModalCreateNewAppOpen(true);
      } else if (val === 'template') {
        // this.isModalCreateWithTemplate(true);
      }
    },
    detailApp(id) {
      this.$router.replace(`/setting/application/${id}`);
    },
    detailGroup(id) {
      this.$router.replace(`/setting/application/group/${id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/setting/jApplicationSetting.vue